import { Navigate, Route, Routes } from 'react-router-dom';
import FinanceLayout from './components/FinanceLayout';
import PendingItemsPage from './pages/PendingItemsPage';
import PlatformInvoicesPage from './pages/PlatformInvoicesPage';
import VisitFeesPage from './pages/VisitFeesPage';
import DeliveryPaymentsPage from './pages/DeliveryPaymentsPage';
import B2BBillingPage from './pages/B2BBillingPage';
import PaymentsToReconcilePage from './pages/PaymentsToReconcilePage';
import BillingAdjustmentsPage from './pages/BillingAdjustmentsPage';
import RefundsPendingPage from './pages/RefundsPendingPage';
import SettlementsPage from './pages/SettlementsPage';
import SettlementConfigPage from './pages/SettlementConfigPage';
import OwnerOverridesPage from './pages/OwnerOverridesPage';

// §A2 route / page structure. `primary` = shown as a pill on < lg; the rest fold into "More ▾".
export const NAV_ITEMS = [
  { path: '/pending', label: 'Important pending items', primary: true, Component: PendingItemsPage },
  { path: '/visit-fees', label: 'Property visit fees', primary: true, Component: VisitFeesPage },
  { path: '/delivery-payments', label: 'Delivery & agent payments', primary: true, Component: DeliveryPaymentsPage },
  { path: '/b2b-billing', label: 'Shared-delivery billing (B2B)', primary: false, Component: B2BBillingPage },
  { path: '/payments-to-reconcile', label: 'Payments to reconcile', primary: true, Component: PaymentsToReconcilePage },
  { path: '/billing-adjustments', label: 'Billing adjustments', primary: false, Component: BillingAdjustmentsPage },
  { path: '/refunds-pending', label: 'Refunds pending', primary: true, Component: RefundsPendingPage },
  { path: '/settlements', label: 'Settlements', primary: true, Component: SettlementsPage },
  { path: '/platform-invoices', label: 'Platform invoices', primary: false, Component: PlatformInvoicesPage },
  { path: '/settings', label: 'Settlement configuration', primary: false, requiresEdit: true, Component: SettlementConfigPage },
  { path: '/owner-overrides', label: 'Owner-specific finance overrides', primary: false, requiresEdit: true, Component: OwnerOverridesPage }
];

export default function FinanceRoutes() {
  return (
    <Routes>
      <Route element={<FinanceLayout />}>
        {NAV_ITEMS.map(({ path, Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
        <Route index element={<Navigate to="/pending" replace />} />
        <Route path="*" element={<Navigate to="/pending" replace />} />
      </Route>
    </Routes>
  );
}
